export default {
    Pace: 'Pace',
    Speed: 'Speed',
    SwimPace: 'SwimPace',
    SwimSpeed: 'SwimSpeed',
    Flying: 'Flying',
    RowingSpeed: 'RowingSpeed',
    RowingPace: 'RowingPace',
    FloorClimbingPace: 'FloorClimbingPace',
    NauticalSpeed: 'NauticalSpeed',
    WheelchairPace: 'WheelchairPace',
    ObstacleRunSpeed: 'ObstacleRunSpeed',
    ObstacleRunPace: 'ObstacleRunPace',
    ResortSkiSpeed: 'ResortSkiSpeed',
    ResortSkiPace: 'ResortSkiPace'
};
